<template>
  <base-container :isLoading="loading">
    <artisan-group style="margin-bottom: 5px" title="预约信息">
      <el-row
        type="flex"
        class="padding-v7"
        justify="space-around"
        align="middle"
      >
        <div>
          预约状态:
          <el-tag
            v-if="bill.id"
            :type="statusMap[bill.status].type"
            size="small"
          >
            <span :class="payStatusMap[bill.payStatus].type">
              {{ payStatusMap[bill.payStatus].label }}
            </span>
            |
            <span>{{ statusMap[bill.status].label }}</span>
          </el-tag>
        </div>
        <div>
          检查室:
          <b v-html="bill.resourceName || '-'"></b>
        </div>
        <div
          v-if="
            bill.id &&
            bill.status != 'wait' &&
            bill.status != 'cancel' &&
            bill.status != 'scrap'
          "
        >
          预约时间:
          <b v-html="bill.reserveDate || '-'"></b>
          <b
            class="margin-h5"
            v-html="(bill.startPoint || '') + '-' + (bill.endPoint || '')"
          ></b>
        </div>
      </el-row>
    </artisan-group>
    <artisan-group title="检查申请单">
      <el-descriptions
        :labelStyle="{ width: '100px' }"
        :column="3"
        size="medium"
        border
      >
        <el-descriptions-item label="申请单号">
          <b>{{ bill.id }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="患者姓名">
          <b>{{ bill.patientName }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="患者性别">
          <b>{{ getGenderLabel(bill.patientGender) }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="出生日期">
          <b>{{ bill.patientBirthday }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          <b>{{ bill.patientPhone }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="开单医生">
          {{ bill.billDoctorName }}
        </el-descriptions-item>
        <el-descriptions-item label="项目名称">
          {{ bill.projectName }}
        </el-descriptions-item>
        <el-descriptions-item label="就诊号">
          {{ bill.clinicNo }}
        </el-descriptions-item>
        <el-descriptions-item label="就诊类型">
          {{ bill.clinicTypeLabel }}
        </el-descriptions-item>
        <el-descriptions-item label="开单科室">
          {{ bill.billDeptName }}
        </el-descriptions-item>
        <el-descriptions-item label="院区" :span="2">
          {{ bill.hosName }}
        </el-descriptions-item>
        <el-descriptions-item label="项目部位" :span="3">
          <b>{{ bill.partNames }}</b>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="3">
          {{ bill.remark }}
        </el-descriptions-item>
      </el-descriptions>
    </artisan-group>
    <artisan-group v-if="bill.sortNo" title="签到序号">
      <div class="align-center">
        <div class="number-code">{{ bill.sortNo }}</div>
      </div>
    </artisan-group>
    <el-card style="margin: 5px" shadow="never" v-if="bill.id">
      <div slot="header">
        <span>预约轨迹</span>
      </div>
      <el-timeline :reverse="true">
        <el-timeline-item
          :timestamp="bill.billTime + ' ' + dateWeek(bill.billTime)"
          placement="top"
          type="success"
          icon="el-icon-top"
        >
          <h3>预约申请</h3>
          <div>
            <div>
              <span class="operator" v-html="'[' + bill.appName + ']'"></span
              >&nbsp;
              <span
                v-html="
                  '患者在' +
                  bill.hosName +
                  '申请了' +
                  bill.projectName +
                  '的项目'
                "
              ></span>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item
          v-for="(log, i) in logs"
          :key="i"
          :timestamp="log.nodeTime + ' ' + dateWeek(log.nodeTime)"
          placement="top"
          type="success"
          icon="el-icon-top"
        >
          <h3 v-html="log.nodeName"></h3>
          <div>
            <div>
              <span class="operator" v-html="'[' + log.appName + ']'"></span
              >&nbsp;
              <span v-html="log.content"></span>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </el-card>
  </base-container>
</template>

<script>
import { get } from "@/api/jc/record";
import { getGenderLabel } from "@/util/util";
export default {
  props: ["query", "billId"],
  data() {
    return {
      loading: false,
      bill: {},
      logs: [],
      statusMap: {
        wait: {
          label: "待预约",
          type: "info",
        },
        ok: {
          label: "已预约",
          type: "parimry",
        },
        cancel: {
          label: "已取消",
          type: "warning",
        },
        sign: {
          label: "已签到",
          type: "success",
        },
        check: {
          label: "已检查",
          type: "success",
        },
        report: {
          label: "已出报告",
          type: "success",
        },
        stop: {
          label: "已停诊",
          type: "danger",
        },
        scrap: {
          label: "已作废",
          type: "danger",
        },
        undo: {
          label: "已爽约",
          type: "danger",
        },
      },
      payStatusMap: {
        paid: {
          label: "已支付",
          type: "color-success",
        },
        unpaid: {
          label: "未支付",
          type: "color-info",
        },
        refund: {
          label: "已退费",
          type: "color-danger",
        },
      },
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    billId() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      const id = this.billId || this.query?.recordId;
      if (id) {
        this.loading = true;
        get({ id })
          .then((res) => {
            let data = res.data.data;
            this.bill = data;
            this.logs = data.logs;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getGenderLabel,
    dateWeek: function (nodeTime) {
      let arr = ["日", "一", "二", "三", "四", "五", "六"];
      let dateObj = new Date(nodeTime);
      let dayOfWeek = dateObj.getDay();
      return "星期" + arr[dayOfWeek];
    },
    getClassName(item) {
      if (item == "已预约") {
        return "ok";
      } else if (item == "已取消") {
        return "cancel";
      } else if (item == "已签到") {
        return "take";
      } else if (item == "停诊") {
        return "stop";
      } else if (item == "爽约") {
        return "undo";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.el-descriptions >>> .el-descriptions__header {
  margin-bottom: 10px !important;
  margin-left: 5px !important;
}
.number-code {
  height: 100px;
  min-width: 100px;
  line-height: 100px;
  text-align: center;
  display: inline-block;
  border-radius: 5%;
  background-color: #409eff;
  color: white;
  font-size: 50px;
}
.operator {
  display: inline-block;
  color: #ff3535;
}
.ok {
  color: #1989fa;
}
.cancel {
  color: #e6a23c;
}
.take {
  color: #67c23a;
}
.stop {
  color: #409eff;
}
.undo {
  color: red;
}
</style>
